import React from "react";

const WarnIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.3 3.3 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.3a2 2 0 0 0-3.4 0Z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12" y2="17" />
    </svg>
);

/**
 * Bloco de introdução em linguagem simples no topo dos painéis técnicos
 * (API e Webhook). Texto à esquerda (largura de leitura confortável) e um
 * mini-diagrama animado opcional à direita, com a nota de "recurso técnico".
 */
export const PanelIntro = ({ icon, iconBg, iconFg, title, children, art }) => (
    <div className="panel-intro">
        <div className="panel-intro__cols">
            <div className="panel-intro__main">
                <div className="panel-intro__head">
                    <span className="panel-intro__icon" style={{ background: iconBg, color: iconFg }}>
                        {icon}
                    </span>
                    <h2>{title}</h2>
                </div>
                <div className="panel-intro__body">{children}</div>
            </div>

            {art && <div className="panel-intro__art">{art}</div>}
        </div>

        <p className="panel-intro__note">
            <WarnIcon />
            <span>
                <strong>Recurso técnico.</strong> Para configurar, conte com um desenvolvedor da sua
                equipe, um freelancer ou uma agência. Documentação completa em{" "}
                <a href="https://api.brinde.me/docs" target="_blank" rel="noopener noreferrer">
                    api.brinde.me/docs
                </a>
                .
            </span>
        </p>
    </div>
);

export default PanelIntro;
